'use strict';

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importDefault(require('react'));

var Icon_1 = __importDefault(require('../Icon'));

var AttachmentLink = function AttachmentLink(props) {
  return react_1.default.createElement(
    Icon_1.default,
    __assign({}, props),
    react_1.default.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.5418 5.51767L10.514 8.54538L9.4533 7.48474L12.4811 4.45703C14.4314 2.50684 17.5934 2.50684 19.5437 4.45702C21.4939 6.40721 21.4939 9.56909 19.5437 11.5193L16.5158 14.547L15.4552 13.4864L18.483 10.4586C19.8475 9.09422 19.8475 6.88207 18.483 5.51766C17.1185 4.15325 14.9063 4.15325 13.5418 5.51767ZM7.4846 9.45337L8.54528 10.514L5.51703 13.5421C4.15257 14.9065 4.15257 17.1187 5.51703 18.4831C6.8815 19.8475 9.09374 19.8475 10.4582 18.4831L13.4865 15.455L14.5471 16.5156L11.5189 19.5437C9.56863 21.4939 6.40662 21.4939 4.45635 19.5437C2.50609 17.5936 2.50609 14.4317 4.45635 12.4815L7.4846 9.45337ZM14.9698 7.96969L7.96976 14.9697L9.03042 16.0304L16.0304 9.03035L14.9698 7.96969Z',
    })
  );
};

AttachmentLink.displayName = 'AttachmentLink';
exports.default = AttachmentLink;
